import React, { useState, useRef, useEffect, useCallback } from "react";
import styles from "./MicrophoneVoiceRecognition.module.css";
import { MicrophoneIcon } from "../../assets/icons/Microphone";
import { StopIcon } from "../../assets/icons/Stop";
import { PlayIcon } from "../../assets/icons/PlayIcon";
import { PauseIcon } from "../../assets/icons/Pause";

import {
  SpeechAceVRFactory,
  fetchSpeechAceVRData,
  handleSpeechAceVRAttemptMetrics,
} from "./Factories/SpeechAceVRFactory";
import {
  WizSpeechVRFactory,
  fetchWizSpeechVRData,
  handleWizSpeechVRAttemptMetrics,
} from "./Factories/WizSpeechVRFactory";

import { useAppGlobalConfig } from "../../providers/AppGlobalConfigContext";
import validateAudio from "./ultis/validateAudio";
import LogProcess from "../StructuredLog/LogProcess";

const MicrophoneComponent = ({
  data,
  blockData,
  lessonId,
  lessonName,
  contentIndex,
  totalIndexes,
  template,
  callbackResponseScore,
  callbackExercisesRecordingAttempts,
  callbackAudioVrRecordingAttempts,
  callbackAudioVrSetValueContentIndex,
  callbackAudioVrSetRecordingAttempts,
  callbackRegisterMetrics,
  step,
  setLetSkip,
  setShowVRErrorDialogue,
}) => {
  const [recording, setRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioBlobUrl, setAudioBlobUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [recordingAttempts, setRecordingAttempts] = useState(0);
  const [wasCheckedAnswer, setWasCheckedAnswer] = useState(false);
  const [erroHandlingScore, setErroHandlingScore] = useState(false);
  const [erroHandlingAudio, setErroHandlingAudio] = useState(false);
  const [erroHandlingAttemptsLimit, setErroHandlingAttemptsLimit] =
    useState(false);
  const mediaRecorderRef = useRef();
  const audioElementRef = useRef();
  const userInfo = JSON.parse(localStorage.getItem("user-info"));

  const { isEmbedMode } = useAppGlobalConfig();
  let tenant = isEmbedMode ? "cupheadless" : "cupfranchise";

  const [engagementTime, setEngagementTime] = useState(0); // Engagement time state
  let engagementStartTimeRef = "";

  // Function to start engagement time tracking
  const startEngagementTime = async () => {
    await LogProcess("warn", `Working At startEngagementTime`);
    engagementStartTimeRef = Date.now(); // Record the start time
    await LogProcess(
      "warn",
      `Closing startEngagementTime ${engagementStartTimeRef}`,
    );
  };

  // Function to stop engagement time tracking
  const stopEngagementTime = async () => {
    await LogProcess(
      "warn",
      `Starting At stopEngagementTime ${engagementStartTimeRef}`,
    );
    const endTime = Date.now(); // Record the end time
    const engagementTime = Math.floor(
      (endTime - engagementStartTimeRef) / 1000,
    ); // Calculate engagement time in seconds
    setEngagementTime(engagementTime); // Set the engagement time
    await LogProcess(
      "warn",
      `Closing Working At stopEngagementTime ${engagementTime}`,
    );
  };

  /// This lógic works for a group of specifics users_id
  // const usersIdForCanary = `"${process.env.REACT_APP_VOICE_RECOGNITION_USERS_CANARY}"`; //"users_id"
  // let provider = usersIdForCanary.includes(userInfo.id) ? "wizspeech" : process.env.REACT_APP_VOICE_RECOGNITION_PROVIDER;

  // It's works, but is implemented for the future
  // This lógic works for whole choosed book
  const bookNameForCanary = `"${process.env.REACT_APP_VOICE_RECOGNITION_BOOK_CANARY}"`; //"NEW W2"
  const currentBookName = localStorage.getItem("currentBookName");
  let provider =
    !currentBookName ||
    currentBookName.trim() === "" ||
    currentBookName.toUpperCase() !== bookNameForCanary.toUpperCase()
      ? process.env.REACT_APP_VOICE_RECOGNITION_PROVIDER
      : "wizspeech";

  const fetchData = useCallback(async () => {
    setWasCheckedAnswer(false);
    setAudioBlob("");
    setAudioBlobUrl("");
    setRecording(false);

    try {
      const currentPhrase = data.en;
      let lastAttempt = recordingAttempts;
      if (provider == "wizspeech") {
        const res = await fetchWizSpeechVRData(
          blockData,
          currentPhrase,
          tenant,
        );
        await LogProcess(
          "info",
          `At fetchData in wizspeech Provider is  ------------ ${provider}`,
        );
        await LogProcess(
          "info",
          `At fetchData in SpeechAce currentPhrase is  ####### ${currentPhrase}`,
        );
        if (res != null && res.success) {
          await LogProcess(
            "warn",
            `At fetchData wizSpeechVRData is ------------ ${JSON.stringify(res)}`,
          );

          // Filter data according to phrase equal to currentPhrase
          lastAttempt =
            res != null && res.data != null && res.data.data != null
              ? res.data.data.attempts >= 3
                ? 3
                : res.data.data.attempts
              : 0;

          console.log("info", `wizSpeechVRData  ------------ `, res);

          // Update recordingAttempts, callback functions as needed
          setRecordingAttempts(lastAttempt);
          callbackAudioVrSetValueContentIndex(contentIndex);
          callbackAudioVrSetRecordingAttempts(lastAttempt);
          callbackExercisesRecordingAttempts(lastAttempt);
        } else {
          setRecordingAttempts(0); // Set attempts to 0 if no data found for progress-tracker
        }
      } else if (provider === "speechace") {
        await LogProcess(
          "info",
          `At fetchData in SpeechAce Provider is  ------------${provider}`,
        );
        const speechAceVRData = await fetchSpeechAceVRData(
          blockData,
          currentPhrase,
          tenant,
        );
        if (speechAceVRData != null && speechAceVRData.success) {
          // Filter data according to phrase equal to currentPhrase
          lastAttempt =
            speechAceVRData != null &&
            speechAceVRData.data != null &&
            speechAceVRData.data.data != null
              ? speechAceVRData.data.data.attempts
              : 0;

          console.log(
            "info",
            `speechAceVRData  ------------ `,
            speechAceVRData,
          );
          console.log(
            "info",
            `speechAceVRData  attempts ------------ `,
            speechAceVRData.data.data.attempts,
          );

          setRecordingAttempts(lastAttempt);
          callbackAudioVrSetValueContentIndex(contentIndex);
          callbackAudioVrSetRecordingAttempts(lastAttempt);
          callbackExercisesRecordingAttempts(lastAttempt);
        } else {
          setRecordingAttempts(0); // Set attempts to 0 if no data found for progress-tracker
        }
      } else {
        await LogProcess(
          "warn",
          `At fetchData Invalid voice recognition provider:${provider}`,
        );
      }
    } catch (error) {
      await LogProcess(
        "Error",
        `At fetchData Error fetching previous attempts: ${error}`,
      );
      setShowVRErrorDialogue(true);
      setLetSkip(true);
    } finally {
      // Always log the process regardless of success or failure
      await LogProcess(
        "info",
        provider === "speechace" || provider === "wizspeech"
          ? "success"
          : "not_found", // Adjust logging based on provider
        `At method fetchData - Calling get Response Status`,
      );
    }
  }, [
    data,
    callbackAudioVrSetValueContentIndex,
    contentIndex,
    callbackAudioVrSetRecordingAttempts,
    callbackExercisesRecordingAttempts,
  ]);

  // Fetching previous attempts after the component mounts
  useEffect(() => {
    fetchData();
  }, [data]);

  // Function for choosing Voice to text provider
  const handleProviderChoice = async (audioBlob) => {
    if (recordingAttempts >= 3) {
      setErroHandlingAttemptsLimit(true);
      throw new Error("The limit of 3 attempts has been exceeded.");
    }

    if (provider == "wizspeech") {
      await LogProcess(
        "info",
        `Working with WizSpeech Provider ------------${provider}`,
      );
      return await WizSpeechVRFactory(
        audioBlob,
        data,
        userInfo,
        lessonName,
        recordingAttempts,
        engagementTime,
        tenant,
      );
    } else if (provider === "speechace") {
      await LogProcess(
        "info",
        `Working with SpeechAce Provider ------------ ${provider}`,
      );
      return await SpeechAceVRFactory(
        audioBlob,
        data,
        userInfo,
        lessonName,
        recordingAttempts,
        engagementTime,
      );
    } else {
      throw new Error("Invalid VR provider", provider);
    }
  };

  // Function for checking the recorded audio answer
  const handleCheckAnswer = async () => {
    try {
      if (!audioBlob) {
        throw new Error("No audio available to check");
      }

      // Validate audio before proceeding
      const isValidAudio = await validateAudio(audioBlob);
      if (!isValidAudio) {
        throw new Error("Invalid audio detected during validation");
      }

      setIsLoading(true);
      const response = await handleProviderChoice(audioBlob);

      if (!response || !response.success) {
        throw new Error(
          response.error || "Error in voice recognition at handleCheckAnswer",
        );
      }

      let metrics = response.data;
      if (!metrics || typeof metrics !== "object") {
        throw new Error(
          "Unexpected response format received in handleCheckAnswer",
        );
      }

      const detailed =
        metrics &&
        metrics.result &&
        metrics.result.detailed &&
        metrics.result.detailed.words
          ? metrics.result.detailed.words
          : [];
      if (!Array.isArray(detailed)) {
        throw new Error("Invalid 'detailed.words' data in response metrics");
      }

      await LogProcess(
        "info",
        `At handleCheckAnswer the handleProviderChoice response is :${JSON.stringify(response)}`,
      );

      if (provider === "speechace" && response.success) {
        await LogProcess(
          "info",
          `At handleProviderChoice Working with SpeechAce Provider : ${provider}`,
        );
        metrics = response.data;

        await LogProcess(
          "info",
          `### metrics at handleSpeechAceVRAttemptMetrics ${JSON.stringify(metrics)} `,
        );

        // Handle metrics using the new method
        await handleSpeechAceVRAttemptMetrics(
          response,
          metrics,
          userInfo,
          data,
          lessonId,
          lessonName,
          totalIndexes,
          blockData,
          recordingAttempts,
          engagementTime,
          callbackResponseScore, // pass the callback function to update the score
          callbackRegisterMetrics,
        );

        setWasCheckedAnswer(true);
      }

      if (provider === "wizspeech" && response.success) {
        await LogProcess(
          "info",
          `At handleCheckAnswer Working with WizSpeech Provider ${provider}`,
        );
        metrics = response.data;

        // Handle metrics using the new method
        await handleWizSpeechVRAttemptMetrics(
          response,
          metrics,
          userInfo,
          data,
          lessonId,
          lessonName,
          totalIndexes,
          blockData,
          recordingAttempts,
          engagementTime,
          callbackResponseScore, // pass the callback function to update the score
          callbackRegisterMetrics,
        );

        setWasCheckedAnswer(true);
      }

      fetchData();
      setErroHandlingScore(false);
      setErroHandlingAudio(false);
      setErroHandlingAttemptsLimit(false);
      setWasCheckedAnswer(true);
      setRecordingAttempts(recordingAttempts + 1); // Update the attempt count
    } catch (error) {
      await LogProcess(`At handleCheckAnswer Error checking answer: ${error}`);
      setErroHandlingScore(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to start recording
  const startRecording = async () => {
    try {
      setErroHandlingScore(false);
      setErroHandlingAudio(false);
      setErroHandlingAttemptsLimit(false);

      setWasCheckedAnswer(false);
      setAudioBlob("");
      setAudioBlobUrl("");
      setRecording(false);

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      const audioChunks = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        const blob = new Blob(audioChunks, { type: "audio/wav" });
        setAudioBlob(blob);
        setAudioBlobUrl(URL.createObjectURL(blob));
        await LogProcess("success", "Recording completed successfully.");
      };

      mediaRecorder.start();
      mediaRecorderRef.current = mediaRecorder;
      setRecording(true);
      startEngagementTime(); // Start engagement time tracking
    } catch (error) {
      await LogProcess("error", `Error starting recording: ${error.message}`);
      setErroHandlingAudio(true);
    }
  };

  // Function to stop recording
  const stopRecording = async () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
      stopEngagementTime(); // Stop engagement time tracking
    }
  };

  // Function to play recorded audio
  const handleAudioPlay = async () => {
    if (audioBlobUrl && audioElementRef.current) {
      try {
        await audioElementRef.current.play();
        setIsPlaying(true);
      } catch (error) {
        await LogProcess("warn", `Audio playback blocked: ${error.message}`);
      }
    } else {
      await LogProcess("warn", "No audio available to play");
    }
  };

  // Function to pause recorded audio
  const handleAudioPause = () => {
    if (audioElementRef.current) {
      audioElementRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Function to continue to the next lesson
  const continueLesson = async () => {
    step("forward", true);
    await LogProcess("success", "Continuing to the next step.");
  };

  return (
    <div className={styles.microphone_container}>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          {/* Recording button */}
          {recordingAttempts < 3 && (
            <button
              className={`${styles.microphone_button} ${recording ? "stop-button" : "start-button"}`}
              onClick={recording ? stopRecording : startRecording}
              disabled={recordingAttempts >= 3}
            >
              {recording ? (
                <>
                  <StopIcon className={styles.microphone_icon} /> Stop
                </>
              ) : (
                <>
                  <MicrophoneIcon className={styles.microphone_icon} /> Start
                  Recording
                </>
              )}
            </button>
          )}

          {/* PlayIcon Audio */}
          {audioBlob && (
            <div>
              <button
                className={styles.microphone_button}
                onClick={isPlaying ? handleAudioPause : handleAudioPlay}
              >
                {isPlaying ? (
                  <PauseIcon className={styles.microphone_icon} />
                ) : (
                  <PlayIcon className={styles.microphone_icon} />
                )}{" "}
                Play Audio
              </button>
              <audio
                ref={audioElementRef}
                src={audioBlobUrl}
                onEnded={handleAudioPause}
              />
            </div>
          )}

          {/*  Check Answer */}
          {audioBlob &&
            !wasCheckedAnswer &&
            recordingAttempts < 3 &&
            !recording && (
              <>
                <button
                  className={styles.check_answer_button}
                  onClick={handleCheckAnswer}
                >
                  Check Answer
                </button>
              </>
            )}

          {((!recording && recordingAttempts > 0) ||
            wasCheckedAnswer ||
            (erroHandlingAudio && recordingAttempts > 0) ||
            (erroHandlingScore && recordingAttempts > 0)) && (
            <button
              className={styles.check_answer_button}
              onClick={async () => {
                if (isPlaying) {
                  await handleAudioPause();
                }
                await continueLesson();
              }}
            >
              {" "}
              Continue
            </button>
          )}

          {/* Error handling */}
          {erroHandlingScore && <p>No speech detected, please try again!</p>}
          {erroHandlingAudio && (
            <p>A problem with audio was detected, please try again late!</p>
          )}
          {erroHandlingAttemptsLimit && (
            <p>The limit of 3 attempts has been exceeded.</p>
          )}
        </>
      )}
    </div>
  );
};

export default MicrophoneComponent;
